<script>
  import I18n from './G_I18n.svelte'
</script>
<div class="text-muted text-center container mt-4">
  <i class="fa-solid fa-exclamation-triangle fa-5x"></i>
  <p><I18n html>Something wrong happens</I18n></p>
</div>